import DebtsApi from '../../apis/Debts';

export default{
    namespaced: true,
    state: {
        debts: [],
        debt: null,
        response_payment: null
    },
    mutations: {
        set_debts (state, data) {
            state.debts = data;
        },
        set_debt (state, data) {
            state.debt = data;
        },
        set_response_payment (state, data) {
            state.response_payment = data;
        }
    },
    actions: {
        selectDebt({commit}, data) {
            commit('set_debt', data);
        },
        async getDebts({commit, dispatch}, filters) {
            return await DebtsApi.get_all(filters)
                .then( response => {
                    commit('set_debts', response.data)
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al listar cuentas por cobrar, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async storeAmortize({commit, dispatch}, payment) {
            commit('set_response_payment', null);
            return await DebtsApi.amortize(payment)
                .then( response => {
                    commit('set_response_payment', response.data);
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'El pago se realizó de forma correcta.'
                    }, {root: true});
                    dispatch('getDebts');                      
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al registrar pago, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
    }
}